@using Resources;

<template>
    <div v-if="!isLoading">

        <div class="sub-header">
            <div class="wrap">
                <div class="language">
                <a :href="store.state.tenant.WebsiteURL">{{ store.locale.backToSite }} <i class="bi bi-chevron-left"></i> </a>
                
                <a href="#" v-on:click="store.setLocale('es')"><img src="@/assets/flags/es.png"></a>
                <a href="#" v-on:click="store.setLocale('fr')"><img src="@/assets/flags/fr.png"></a>
                <a href="#" v-on:click="store.setLocale('it')"><img src="@/assets/flags/it.png"></a>
                <a href="#" v-on:click="store.setLocale('de')"><img src="@/assets/flags/de.png"></a>
                <a href="#" v-on:click="store.setLocale('en')"><img src="@/assets/flags/gb.png"></a>
                <a href="#" v-on:click="store.setLocale('nl')"><img src="@/assets/flags/nl.png"></a>
                </div>
            </div>
        </div>

        <div v-if="store.state.notification">
            <div
                :style="{ color: store.state.notification.FontColor, backgroundColor: store.state.notification.BackgroundColor, padding: '1.2rem' }">
                <strong>{{ store.getNotificationTitle(store.state.notification) }}</strong>
                <p style="margin: 0">
                    {{ store.getNotificationMessage(store.state.notification) }}
                </p>
            </div>
        </div>
        <main class="main" role="main">
            <a href="#top" class="anchor"></a>
            <mf-header :store="store" :cartviewclicked="viewCartClicked" />

            <section class="site-title color no-margin">
                <div class="wrap">
                    <h1 style="color: #ffffff">
                        {{ store.locale.onlineReservations }}
                    </h1>
                </div>
            </section>

            <section id="main">
                <mf-reservation-shop v-if="!showShoppingCart" :store="store"
                    :shoppingcartchanged="onSelectedArticlesChanged" :cartviewclicked="viewCartClicked"
                    :is-location-loaded="isLocationLoaded"></mf-reservation-shop>

                <mf-shoppingcart v-else :store="store" :articles="store.state.cart.articles"
                    :pricing="store.state.cart.pricing" :percentage-to-pay="store.state.tenant.WebsitePercentageToPay"
                    :closecart="closeShoppingCart"></mf-shoppingcart>
            </section>
            
            <footer class="footer black" role="contentinfo" id="footer" v-if="store.state">
                <div class="wrap">
                    <div class="row">
                        <article class="one-half">
                            <h6> {{ store.locale.about }} {{ store.state.tenant.Name }}</h6>
                            <p v-html="store.state.tenant.About"></p>
                        </article>

                        <article class="one-half">
                            <h6>{{ store.locale.contactUs }}</h6>
                            <p>{{ store.locale.contactUsBy }}:</p>
                            <p class="contact-data"><a v-bind:href="'tel:' + store.state.tenant.PhoneNumber">
                                <i class="icon bi bi-telephone"></i>
                                        {{ store.state.tenant.PhoneNumber}}</a></p>
                            <p class="contact-data"><a v-bind:href="'mailto:' + store.state.tenant.EmailAddress">
                                <i class="icon bi bi-envelope"></i>
                                {{ store.state.tenant.EmailAddress}}</a></p>
                            <p class="contact-data"><a :href="store.state.tenant.WebsiteURL" target="_blank">
                                <i class="icon bi bi-globe-europe-africa"></i> {{ store.locale.visitOurWebsite }}</a>
                            </p>
                        </article>

                    </div>

                    <div class="copy">

                        <p>&copy; 2012 - {{ new Date().getFullYear() }} - <a href="http://www.mijnfietsverhuur.nl"
                                title="mijnfietsverhuur.nl">mijnfietsverhuur.nl</a> </p>

                        <nav role="navigation" class="foot-nav">
                            <ul>
                                <li><a href="#" v-on:click="store.showTerms = true">{{ store.locale.terms }}</a></li>
                                <li>|</li>
                                <li><a href="#top" class="anchor animated" title="Back to top">Top</a></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </footer>
        </main>

        <mf-modal v-if="store.showTerms" @close="store.showTerms = false">
            <h1 slot="header" class="text-center">{{ store.locale.terms }}</h1>
            <div slot="body">
                <div class="row">
                    <div class="col-12" v-html="store.formatMarkDown(store.state.tenant.TermsAndConditions)">
                    </div>
                </div>

            </div>
        </mf-modal>

        <mf-modal v-if="store.state.showNoSupply" @close="store.state.showNoSupply = false">
            <h1 slot="header">Onvoldoende voorraad</h1>
            <div slot="body">

                <div v-if="store.state.noSupply.isFixedPriceProduct">
                    Helaas, {{ store.state.noSupply.title }} is niet meer beschikbaar.
                </div>

                <div v-else>
                    <div>
                        De {{ store.state.noSupply.title }} heeft onvoldoende voorraad voor de volledige periode.<br />
                        U kunt hieronder de actuele voorraad zien en eventueel uw huurperiode hierop afstemmen.
                    </div>
                    <div v-if="store.state.noSupply.isLoading">
                        <div class="article-loader sk-fading-circle">
                            <div class="sk-circle1 sk-circle"></div>
                            <div class="sk-circle2 sk-circle"></div>
                            <div class="sk-circle3 sk-circle"></div>
                            <div class="sk-circle4 sk-circle"></div>
                            <div class="sk-circle5 sk-circle"></div>
                            <div class="sk-circle6 sk-circle"></div>
                            <div class="sk-circle7 sk-circle"></div>
                            <div class="sk-circle8 sk-circle"></div>
                            <div class="sk-circle9 sk-circle"></div>
                            <div class="sk-circle10 sk-circle"></div>
                            <div class="sk-circle11 sk-circle"></div>
                            <div class="sk-circle12 sk-circle"></div>
                        </div>
                    </div>

                    <div class="mt-4 row" v-else>
                        <div v-for="(date, index) in store.state.noSupply.availabilityDates" :key="'supplydate-' + index"
                            class="col-xs-1 p-0 mr-1">
                            <div v-if="date.Available < store.state.noSupply.requestedAmount"
                                class="alert alert-danger text-center">
                                <div>
                                    {{ parseDate(date.Date).format("dddd") }}<br />
                                    {{ parseDate(date.Date).format("D/M") }}
                                    <br />
                                    <strong>{{ date.Available }}</strong>
                                </div>
                            </div>
                            <div v-else class="alert alert-success text-center">
                                <div>
                                    {{ parseDate(date.Date).format("dddd") }}<br />
                                    {{ parseDate(date.Date).format("D/M") }}
                                    <br />
                                    <strong>{{ date.Available }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </mf-modal>

    </div>
</template>

<script>
import { marked } from 'marked';
import DOMPurify from 'dompurify';

import bootbox from 'bootbox';
import axios from 'axios';
import moment from 'moment';
import Header from '@/components/Header.vue';
import ReservationShop from '@/components/ReservationShop.vue';
import Modal from '@/components/Modal.vue';
import ShoppingCart from '@/components/ShoppingCart.vue';
import translations from '@/i18n/labels.json';


var store = {
    debug: false,
    locale: translations[0],
    showTerms: false,
    state: {
        categories: [],
        workingHours: [],
        accommodations: [],
        timesuggestions: [],
        notification: null,
        locations: [],
        tenant: {},
        cart: {
            articles: [],
            blocks: [],
            pricing: {
                subTotal: 0,
                discount: 0,
                reservationCosts: 0,
                extraDiscount: 0,
                deposit: 0,
                SafeplanTotal: 0
            }
        },
        hasDeliveryAvailableOnDay: false,
        hasDiscountAvailableOnDay: true,
        selectedLocationLoaded: false,
        selectedLocation: {},
        selectedCategory: {},
        departureDate: null,
        returnDate: null,
        showNoSupply: false,
        noSupply: {
            availabilityDates: [],
            title: "",
            requestedAmount: 0,
            isLoading: false
        }
    },

    changeTermsToggle(value) {
        this.state.showTerms = value;
    },
    defaultPlaceOfStayDescription() {
        if (this.numberOfDays() == 1) {
            return this.state.tenant.DefaultSingleDayAccommodation;
        }
        return "";
    },

    getStartDayMessage(date) {

        let message = this.getReservationRemarkForDay(date);
        if (this.getWorkingHourSetOnDay(date).length === 0) {
            message = this.state.tenant.DepartureDayClosedMessage;
        }

        return message;
    },

    formatMarkDown(val) {
        if (val == undefined || val == null) {
            return "";
        }
        return DOMPurify.sanitize(marked(val));
    },

    // get a remark for the date (if any)
    getReservationRemarkForDay(date) {

        let workingHoursSet = this.getWorkingHourSetOnDay(date);

        if (workingHoursSet.length > 0) {

            let departureTimeRemark = workingHoursSet[0];

            if (departureTimeRemark != undefined) {
                return departureTimeRemark.Remark ? departureTimeRemark.Remark : "";
            }
        }
        return "";
    },

    getWorkingHourSetOnDay(date) {

        if (date == null || !date.isValid() || !this.state.workinghours) {
            return [];
        }

        let workingHoursSet = this.state.workinghours.filter(x => moment(x.DateFrom, "YYYY-MM-DD").isSameOrBefore(moment(date).format("YYYY-MM-DD")));
        const results = workingHoursSet[workingHoursSet.length - 1].Schedule.filter(x => x.DayOfWeek === date.day()).sort(function (a, b) {
            return parseInt(a.StartTime.replace(":", "")) - parseInt(b.StartTime.replace(":", ""))
        });
        return results;
    },

    getArticlePrice(article) {
        return article.LinePriceTotal;
    },
    getTotalSafeplan(article) {
        return article.LineSafeplanTotal;
    },

    getReturnDayMessage(date) {
        let message = this.getReservationRemarkForDay(date);

        if (this.getWorkingHourSetOnDay(date).length === 0) {
            message = this.state.tenant.ReturnDayClosedMessage;
        }

        return message;
    },

    getNotificationTitle(notification) {

        let title = notification.Translations.filter(x => x.ISO == 'nl')[0].Title;

        if (this.locale.locale != 'nl') {
            let val = this.locale.locale == 'en' ? 'uk' : this.locale.locale;
            let translation = notification.Translations.filter(x => x.ISO == val);
            title = translation.length == 1 && translation[0].Title !== '' ? translation[0].Title : title;
        }


        return title;
    },

    getNotificationMessage(notification) {

        let decription = notification.Translations.filter(x => x.ISO == 'nl')[0].Description;

        if (this.locale.locale != 'nl') {
            let val = this.locale.locale == 'en' ? 'uk' : this.locale.locale;
            let translation = notification.Translations.filter(x => x.ISO == val);
            decription = translation.length == 1 && translation[0].Description !== '' ? translation[0].Description : decription;
        }
        return decription;
    },


    getArticleTitle(item) {

        let title = item.Title;

        if (!item.Languages)
            return item.Title;

        if (this.locale.locale != 'nl') {
            let val = this.locale.locale == 'en' ? 'uk' : this.locale.locale;
            let translation = item.Languages.filter(x => x.ISO == val);
            title = translation.length == 1 ? translation[0].Title : item.Title;
        }

        return title.length == 0 ? item.Title : title;

    },

    getArticleDescription(item) {
        let description = item.Description;

        if (!item.Languages)
            return description;

        if (this.locale.locale != 'nl') {
            let val = this.locale.locale == 'en' ? 'uk' : this.locale.locale;
            let translation = item.Languages.filter(x => x.ISO == val);
            description = translation.length == 1 ? translation[0].Description : item.Description;
        }

        return description.length == 0 ? item.Description : description;
    },

    numberOfArticles() {
        let articles = this.state.cart.articles;
        let articleCount = (articles || []).reduce(function (r, a) {
            return r + (a.Amount || 0);
        }, 0);

        let blockCount = (this.state.cart.blocks || []).reduce(function (r, a) {
            return r + (a.Amount || 0);
        }, 0);
        return articleCount + blockCount;
    },

    numberOfDays() {
        if (this.state.returnDate)
            return this.state.returnDate.diff(this.state.departureDate, 'days') + 1;
        return 1;
    },
    setLocale(locale) {
        this.locale = translations.filter(x => x.locale === locale)[0];
    },
    dispatch(method, payload) {
        switch (method) {
            case 'updatecart':
                this.updateCart(payload);
                break;
            case 'setlocation':
                this.setLocation(payload);
                break;
        }
    },
    calculateArticleTotal(article) {
        this.state.departureDate = moment(this.state.departureDate);
        this.state.returnDate = moment(this.state.returnDate);
        if (this.state.departureDate == null || this.state.returnDate == null) {
            //bootbox.alert("@Resources.MsgSelectPeriod");
            article.Amount = 0;
            this.$nextTick(() => {
                this.$refs.depDate.focus();
            });
            return;
        }
        let _departureDate = moment(this.state.departureDate).clone();
        let _returnDate = moment(this.state.returnDate).clone();

        var that = this;
        var maxRentOutDuration = article.MaxRentOutDuration;
        var minRentOutDuration = article.MinRentOutDuration;
        if (maxRentOutDuration == 0) {
            maxRentOutDuration = 99999999;
        }
        if (minRentOutDuration == 999999999) {
            minRentOutDuration = 0;
        }


        var duration = moment.duration(_returnDate.diff(_departureDate));
        var hours = duration.asHours();

        if (hours > maxRentOutDuration) {
            let maxDuration = maxRentOutDuration + " @Resources.lblHour";
            if (maxRentOutDuration > 8) {
                let days = Math.floor(maxRentOutDuration / 24) + 1;
                maxDuration = days + "  @Resources.lblDay (en)"
            }

            bootbox.alert(this.getArticleTitle(article) + " @Resources.lblHasMaximumRentalPeriodOf " + maxDuration);
            article.Amount = 0;
            return false;
        }

        let numberOfDays = moment.duration(_returnDate.startOf('day').diff(_departureDate.startOf('day'))).asDays() + 1;
        let minimalNumberOfDays = Math.floor(minRentOutDuration / 24);


        if (numberOfDays < minimalNumberOfDays) {

            let maxDuration = minRentOutDuration + " @Resources.lblHour";
            if (minRentOutDuration > 8) {
                let days = Math.floor(minRentOutDuration / 24);
                maxDuration = days + " @Resources.lblDay (en)"
            }

            bootbox.alert(this.getArticleTitle(article) + " @Resources.lblHasMinimalRentalPeriodOf " + maxDuration);
            article.Amount = 0;
            return false;
        }


        that = this;
        axios.get(`/api/article/${article.Id}`, {
            params: {
                startDate: this.state.departureDate.format("YYYY-MM-DDTHH:mm"),
                returnDate: this.state.returnDate.format("YYYY-MM-DDTHH:mm"),
                locationId: store.state.selectedLocation.Id
            }
        }).then(availabilityResponse => {
            if (Number(article.Amount) > Number(availabilityResponse.data.Amount)) {
                store.state.noSupply.requestedAmount = article.Amount;
                store.state.noSupply.title = article.Title;
                store.state.noSupply.isFixedPriceProduct = article.FixedPrice > 0;
                store.state.noSupply.isLoading = true;
                store.state.showNoSupply = true;
                article.Amount = availabilityResponse.data.Amount;

                axios.get(`/api/article/${article.Id}/availability/dates`, {
                    params: {
                        startDate: store.state.departureDate.format("YYYY-MM-DDTHH:mm"),
                        returnDate: store.state.returnDate.format("YYYY-MM-DDTHH:mm"),
                        locationId: store.state.selectedLocation.Id
                    }
                }).then(response => {
                    store.state.noSupply.availabilityDates = response.data;
                    store.state.noSupply.isLoading = false;
                });
            }

            article.LineDiscount = availabilityResponse.data.Discount * article.Amount;
            article.LinePriceTotal = (availabilityResponse.data.PriceTotal * article.Amount) - article.LineDiscount;
            article.LineSafeplanTotal = availabilityResponse.data.SafeplanTotal;
            article.LinePriceTotalFormatted = article.LinePriceTotal.toCurrencyString();
            that.state.hasDeliveryAvailableOnDay = availabilityResponse.data.DeliveryAvailable;
            that.state.hasDiscountAvailableOnDay = availabilityResponse.data.IsDiscountEnabled;
            //console.log(availabilityResponse.data.SafeplanTotal);
            store.updateCart();
        });
    },
    recalculateAll() {
        this.getArticlesInCart().map(x => this.calculateArticleTotal(x));
    },
    getArticlesInCart() {
        let _articles = [];
        this.state.categories.map(category => {
            if (category.Articles == null) return;
            let articlesFromCategory = category.Articles.filter(article => article.Amount > 0);
            articlesFromCategory.map(y => _articles.push(y));
        });


        return _articles.filter(article => !this.state.selectedLocation.BlockedArticles.includes(article.Id));

    },
    getBlocksInCart() {
        return this.state.cart.blocks;
    },
    getUnDeliverableItemsInCart() {
        return [...this.getArticlesInCart().filter(x => !x.DeliveryAvailable), ...this.getBlocksInCart().filter(x => !x.DeliveryAvailable)];
    },
    getRelatedArticlesCart(cart) {
        let _articles = [];
        cart.map(article => {
            let relatedArticles = article.Related.filter(related => related.Amount > 0);
            relatedArticles.map(y => _articles.push(y));
        });
        return _articles;
    },
    gotoTop() {
        let top = document.getElementById("top").offsetTop;
        window.scrollTo(0, top);
    },
    updateCart() {
        if (this.debug) console.log('updateCart triggered');
        let that = this;


        let DEPOSITMODE_SUM_ALL = "SUM_ALL"; // sum all article * amount
        let DEPOSITMODE_PER_ORDER = "PER_ORDER"; // highest deposit only

        let depositMode = this.state.tenant.DepositMode;

        let articlesInCart = this.getArticlesInCart();
        let relatedArticlesInCart = this.getRelatedArticlesCart(articlesInCart);
        let blocksInCarts = this.getBlocksInCart();

        let articlesSubTotal = (articlesInCart || []).reduce(function (r, a) {
            return r + that.getArticlePrice(a);
        }, 0);

        let articlesSafeplanTotal = (articlesInCart || []).reduce(function (r, a) {
            return r + that.getTotalSafeplan(a);
        }, 0);

        let relatedArticlesSubTotal = (relatedArticlesInCart || []).reduce(function (r, a) {
            return r + that.getArticlePrice(a);
        }, 0);

        let blockSubTotal = (blocksInCarts || []).reduce(function (r, a) {
            return r + (a.Price * a.Amount || 0);
        }, 0);

        let depositTotal = 0;

        if (depositMode == DEPOSITMODE_SUM_ALL) { // sum all article * amount
            let articlesDeposit = (articlesInCart || []).reduce(function (r, a) {
                return r + (a.Deposit * a.Amount || 0);
            }, 0);

            let relatedArticlesSubTotal = (relatedArticlesInCart || []).reduce(function (r, a) {
                return r + (a.Deposit * a.Amount || 0);
            }, 0);

            depositTotal = articlesDeposit + relatedArticlesSubTotal;
        }

        if (depositMode == DEPOSITMODE_PER_ORDER) { // highest deposit only

            let currentDeposit = 0;
            articlesInCart.map(x => {
                if (x.Deposit > currentDeposit) {
                    currentDeposit = x.Deposit;
                }
            });

            relatedArticlesInCart.map(x => {
                if (x.Deposit > currentDeposit) {
                    currentDeposit = x.Deposit;
                }
            });

            depositTotal = currentDeposit;
        }

        this.state.cart = {
            articles: articlesInCart,
            relatedArticles: relatedArticlesInCart,
            blocks: blocksInCarts,
            pricing: {
                subTotal: articlesSubTotal + relatedArticlesSubTotal + blockSubTotal,
                deposit: depositTotal,
                reservationCosts: Number(this.state.tenant.WebsiteReservationCosts),
                discount: 0,
                SafeplanTotal: articlesSafeplanTotal
            }
        };

        this.saveState();
    },

    saveState() {
        const now = new Date();
        const expirationDate = now.getTime() + 10 * 60 * 1000;


        const item = {
            value: this.state,
            expiry: expirationDate,
        };

        localStorage.setItem("state", JSON.stringify(item));
    },
    setLocation(value, cb) {
        this.state.selectedLocation = value;
        this.selectedLocationLoaded = false;

        let referenceTable = "BranchLocation";

        if (isNaN(value.Id)) {
            referenceTable = "Partner";
        }

        axios.post(`/api/location/${value.Id}/workinghours`, { ReferenceTable: referenceTable })
            .then((result) => {
            this.state.workinghours = result.data;
            const workingHoursSorted = this.state.workinghours.sort((a, b) => moment(a.DateFrom, 'YYYY-MM-DD').diff(moment(b.DateFrom, 'YYYY-MM-DD')));

            const getDatesOfDayOfWeekInPeriod = (start, end, dayOfWeek) => {
                var result = [];
                var current = start.clone();

                while (current.isSameOrBefore(end)) {
                if (current.day() === dayOfWeek) {
                    result.push(current.clone().format('YYYY-MM-DDT00:00'));
                }
                current.add(1, 'day');
                }

                return result;
            };

            let blockedWorkingHours = [];
            workingHoursSorted.map(w => {

                let currentScheduleStart = moment(w.DateFrom, 'YYYY-MM-DD').startOf('day');
                let nextScheduleStart = workingHoursSorted.filter(x => moment(x.DateFrom, 'YYYY-MM-DD').isAfter(currentScheduleStart));

                let checkStartDay = moment();

                if (currentScheduleStart.isBefore(checkStartDay)) {
                currentScheduleStart = checkStartDay;
                }

                let checkUntillDay = currentScheduleStart.clone().add(10, 'months');
                nextScheduleStart = nextScheduleStart.length > 0 ? moment(nextScheduleStart[0].DateFrom, 'YYYY-MM-DD').startOf('day') : checkUntillDay;

                if (nextScheduleStart.isAfter(checkUntillDay)) {
                nextScheduleStart = checkUntillDay;
                }

                for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
                const schedule = w.Schedule.filter(y => y.DayOfWeek == dayOfWeek);
                if (schedule.length == 0) {
                    // no day in this period, so closed
                    // fetch all dates from the start of this period untill the start of the next period
                    let days = getDatesOfDayOfWeekInPeriod(currentScheduleStart.add(-1, 'days'), nextScheduleStart, dayOfWeek);
                    blockedWorkingHours.push(days);
                }
                }

            });
            let originalBlocked = [...this.state.selectedLocation.BlockedDates];
            this.state.selectedLocation.BlockedDates = []
            this.state.selectedLocation.BlockedDates = originalBlocked.concat(...blockedWorkingHours);
            })
            .then(() => {
            this.recalculateAll();
            if (cb) cb();
            });

        //this.updateCart();
    },
    setPeriod(departureDate, returnDate) {
        //console.log('setPeriod triggered with', departureDate, returnDate);
        this.state.departureDate = departureDate;
        this.state.returnDate = returnDate;
        this.recalculateAll();
    },
    setSelectedCategory(value) {
        if (this.debug) console.log('setSelectedCategory triggered with', value);
        this.state.selectedCategory = value;
    }
}

export default {
    data: function () {
        return {
            isLoading: false,
            showShoppingCart: false,
            isLocationLoaded: false,
            shoppingCart: {
                articles: []
            },
            store: store,
        }
    },
    components: {
        'mf-header': Header,
        'mf-reservation-shop': ReservationShop,
        'mf-modal': Modal,
        'mf-shoppingcart': ShoppingCart,
    },
    created: function () {
        this.initialize();
    },
    methods: {
        initialize() {

            this.isLoading = true;
            axios.defaults.headers.common['Accept-Language'] = 'nl-NL';

            var previousState = localStorage.getItem("state");
            if (previousState) {

                const item = JSON.parse(previousState);
                const now = new Date();

                if (now.getTime() > item.expiry) {
                    localStorage.removeItem("state");
                } else {
                    this.store.state = item.value;
                }
            }

            if (this.store.state.locations.length == 0) {
                axios.get("/api/account")
                    .then(response => {
                        const data = response.data;
                        this.store.state.categories = data.ArticleCategories;
                        this.store.state.accommodations = data.Accommodations;
                        this.store.state.timesuggestions = data.TimeSuggestions;
                        this.store.state.locations = data.Locations;
                        this.store.state.tenant = data.Data;
                        this.store.state.notification = data.Notification;
                        this.isLoading = false;

                        this.store.setLocation(this.store.state.locations[0], () => this.isLocationLoaded = true);

                        document.title = this.store.state.tenant.Name;
                        this.store.saveState();
                    })
                    .catch(error => {
                        console.error("There was an error fetching the account data:", error);
                        this.isLoading = false;
                    });
            } else {
                this.isLoading = false;
                this.store.setLocation(this.store.state.locations[0], () => this.isLocationLoaded = true);
                document.title = this.store.state.tenant.Name;
            }



        },
        onSelectedArticlesChanged(shoppingCart) {
            this.shoppingCart = shoppingCart;
        },
        viewCartClicked() {
            this.store.gotoTop();
            this.showShoppingCart = true;
        },
        closeShoppingCart() {
            this.store.gotoTop();
            this.showShoppingCart = false;
        },
        parseDate(dt) {
            return moment(dt);
        }
    }
};
</script>
